import { Dropdown } from 'antd'
import type { DropdownProps } from 'antd'

/**
 * Canonical anchored action menu for ⋯ / more-icon triggers.
 * Thin wrapper ensuring consistent overlay chrome and click trigger.
 */
export default function VistoeraActionMenu(props: DropdownProps) {
  const { overlayClassName, trigger = ['click'], ...rest } = props
  return (
    <Dropdown
      {...rest}
      trigger={trigger}
      overlayClassName={['vistoera-action-menu-overlay', overlayClassName].filter(Boolean).join(' ')}
    />
  )
}
